import {
  mdiBullhornVariantOutline,
  mdiSort,
  mdiAccountEdit,
  mdiExport,
  mdiHelpCircleOutline,
  mdiTournament,
  mdiRayStartArrow,
  mdiAccountCowboyHatOutline,
  mdiGoogle
} from '@mdi/js'

export const mdIconMap = {
  mdiBullhornVariantOutline,
  mdiSort,
  mdiAccountEdit,
  mdiExport,
  mdiHelpCircleOutline,
  mdiTournament,
  mdiRayStartArrow,
  mdiAccountCowboyHatOutline,
  mdiGoogle
} as const

export type MdIconType = keyof typeof mdIconMap
